import RoadMajor from './RoadMajor'
import Road from './Road'
import color from './colorThemes'
import config from '../../../config'

const { minZoom, maxZoom } = config.map
const start = minZoom + 1

export default {
  ...RoadMajor,
  id: 'roadMajorLabel',
  type: 'symbol',
  filter: [
    ...Road.filter,
    ['in', 'type', 'motorway', 'primary', 'secondary', 'tertiary', 'trunk'],
  ],
  minzoom: start,
  layout: {
    'symbol-placement': 'line',
    'symbol-spacing': 1000,
    'text-field': '{name}',
    'text-font': ['FiraSansCompressed-SemiBold'],
    'text-letter-spacing': 0.01,
    'text-size': {
      stops: [[start, 12], [maxZoom, 27]],
    },
  },
  paint: {
    'text-color': color.roadMajorLabel,
    'text-halo-color': color.halo,
    'text-halo-width': 1,
  },
}
